import { atom } from 'recoil'

export const modalCheckupState = atom({
  key: 'ModalCheckupState',
  default: {
    show: false,
    checkup: undefined,
    isSending: false,
    isFethingModalState: false,
    error: false,
    showModalBeingSent: false,
    dynamicFieldsOptionEnabled: false,
    wrongDynamicTags: [],
    checkLiquidCode: true,
    checkAttachments: true,
    checkDynamicContents: true,
    checkSize: true,
    checkBlacklistResult: true,
    checkContent: true,
    checkLinksWoTracking: true,
    checkUnsubscribeLink: true,
    checkMaxSize: true,
    checkPreheader: true,
    checkWebAnalytics: true,
    checkWorkflowWarning: false,
    addToWhiteList: [],
    silencedAlertsArray: [],
    silencedCheck: false,
    blockToDisplay: []
  }
})
